/**
 * A room's windows, doors and openings with their geometry, for the valance's
 * opening check (`valances.js`). Post-Phase-5 a room's opening copies are
 * slim references (`structureOpeningId`); the geometry lives on the
 * structure's own copies, so every reader of cabinet trim hands the room
 * through this first — the same join the run engine makes (`getRunOpenings`
 * + `hydrateRoomOpenings`). Pure.
 */
const { getRunOpenings } = require('../cabinet-runs/editResolve');
const { hydrateRoomOpenings } = require('../openings/openingSync');

const KEY = Object.freeze({
  door: 'doors',
  window: 'windows',
  opening: 'openings',
});

/**
 * The room with each opening copy resolved against the structure's (a
 * structure doc, or the viewer's data: `structureWindows`, else `windows`,
 * and the same for doors and openings). The same room when there is no
 * structure or it has none.
 */
function withStructureOpenings(room, structure) {
  if (!room || !structure) return room;
  const byKind = { doors: [], windows: [], openings: [] };
  for (const o of getRunOpenings(structure)) byKind[KEY[o._kind]].push(o);
  const any =
    byKind.doors.length + byKind.windows.length + byKind.openings.length;
  return any ? hydrateRoomOpenings(room, byKind) : room;
}

module.exports = { withStructureOpenings };
